// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 250) return "static/chunks/250-107fee9d7f706b0e.js";
	if (chunkId === 668) return "static/chunks/668-df4dc4463c91d827.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"310":"ca6a8555a46f8869","481":"12fc244aa827cd4a","624":"a50857a437c0a29b","977":"6b62103512522f1b","980":"2b8c623e6516ae64","987":"91b5e7762385ef76"}[chunkId] + ".js";
};